/* eslint-disable */
/**
 * Consistent header for AI feature pages.
 * Includes project selector, title, description, and optional quick links.
 */
import { Box, Breadcrumbs, Button, Grid, Link, Typography, useTheme } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ProjectSelector from "./ProjectSelector";

const AI_QUICK_LINKS = [
  { label: "Content Strategy", path: "/ai-content-strategy" },
  { label: "SEO Autopilot", path: "/ai-autopilot" },
  { label: "A/B Testing", path: "/ai-ab-testing" },
];

export default function AiPageHeader({
  title,
  description,
  projectId,
  onProjectChange,
  showProjectSelector = true,
  showQuickLinks = false,
  breadcrumbItems = [],
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleProjectChange = (id) => {
    onProjectChange?.(id);
    // Update URL with projectId for deep linking
    if (id) {
      const params = new URLSearchParams(searchParams);
      params.set("projectId", id);
      navigate({ pathname: window.location.pathname, search: params.toString() }, { replace: true });
    }
  };

  const goToAiPage = (path) => {
    const url = projectId ? `${path}?projectId=${projectId}` : path;
    navigate(url);
  };

  return (
    <Box sx={{ mb: 3 }}>
      {breadcrumbItems.length > 0 && (
        <Breadcrumbs
          sx={{ mb: 1 }}
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link
            underline="hover"
            color="inherit"
            href="#"
            onClick={e => {
              e.preventDefault();
              navigate("/websitelist");
            }}
          >
            Projects
          </Link>
          {breadcrumbItems.map((item, i) => (
            <Typography key={i} color="text.primary" variant="body2">
              {item}
            </Typography>
          ))}
        </Breadcrumbs>
      )}

      <Grid container spacing={2} alignItems="flex-start" justifyContent="space-between">
        <Grid item xs={12} md={showProjectSelector ? 8 : 12}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
            {title}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </Grid>

        {showProjectSelector && (
          <Grid item xs={12} md={4}>
            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 600 }}>
              Website
            </Typography>
            <ProjectSelector
              value={projectId}
              onChange={handleProjectChange}
              placeholder="Select a website"
              fullWidth
            />
          </Grid>
        )}
      </Grid>

      {showQuickLinks && (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            mt: 2,
            pt: 2,
            borderTop: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Typography variant="body2" color="text.secondary" sx={{ mr: 1, alignSelf: "center" }}>
            AI Tools:
          </Typography>
          {AI_QUICK_LINKS.map(link => (
            <Button
              key={link.path}
              size="small"
              variant="text"
              onClick={() => goToAiPage(link.path)}
              sx={{ textTransform: "none", minWidth: "auto", px: 0.5 }}
            >
              {link.label}
            </Button>
          ))}
        </Box>
      )}
    </Box>
  );
}
